import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExpandedTooltip } from '@livable/saas-react-components';
import { BalanceStatus } from 'src/components/general/BalanceStatus';
import RippleEffect from 'src/components/general/RippleEffect';
import useStyles from '../styles';
import { observer } from 'mobx-react-lite';
export const BalanceCell = observer(_ref => {
  var _params$row, _params$row2, _params$row3, _params$row4;
  let params = _ref.params;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", null, !params.row.accountId ? /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.disabledCellText, " ").concat(classes.flex)
  }, "N/A") : /*#__PURE__*/React.createElement(React.Fragment, null, params.row.accountBalanceStatus && params.row.accountBalanceStatus === 'Overdue' && /*#__PURE__*/React.createElement(ExpandedTooltip, {
    hideOnMobile: true,
    placement: "top",
    title: t('residencies_page.balance_overdue'),
    type: "error"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.tooltipContent
  }, /*#__PURE__*/React.createElement(RippleEffect, {
    className: "".concat((_params$row = params.row) !== null && _params$row !== void 0 && _params$row.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
  }, "$".concat(params.row.currentBalance ? parseFloat(params.row.currentBalance).toFixed(2) : '0'), /*#__PURE__*/React.createElement(BalanceStatus, {
    status: params.row.accountBalanceStatus,
    row: params.row,
    hideText: true
  })))), params.row.accountBalanceStatus && params.row.accountBalanceStatus === 'Ok' && /*#__PURE__*/React.createElement(ExpandedTooltip, {
    hideOnMobile: true,
    placement: "top",
    title: t('residencies_page.balance_ok'),
    type: "success"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.tooltipContent
  }, /*#__PURE__*/React.createElement(RippleEffect, {
    className: "".concat((_params$row2 = params.row) !== null && _params$row2 !== void 0 && _params$row2.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
  }, "$".concat(params.row.currentBalance ? parseFloat(params.row.currentBalance).toFixed(2) : '0'), /*#__PURE__*/React.createElement(BalanceStatus, {
    status: params.row.accountBalanceStatus,
    row: params.row,
    hideText: true
  })))), params.row.accountBalanceStatus && params.row.accountBalanceStatus === 'Due' && /*#__PURE__*/React.createElement(ExpandedTooltip, {
    hideOnMobile: true,
    placement: "top",
    title: t('residencies_page.due_approaching'),
    type: "warning"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.tooltipContent
  }, /*#__PURE__*/React.createElement(RippleEffect, {
    className: "".concat((_params$row3 = params.row) !== null && _params$row3 !== void 0 && _params$row3.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
  }, "$".concat(params.row.currentBalance ? parseFloat(params.row.currentBalance).toFixed(2) : '0'), /*#__PURE__*/React.createElement(BalanceStatus, {
    status: params.row.accountBalanceStatus,
    row: params.row,
    hideText: true
  })))), !params.row.accountBalanceStatus && /*#__PURE__*/React.createElement(RippleEffect, {
    className: "".concat((_params$row4 = params.row) !== null && _params$row4 !== void 0 && _params$row4.isEnrolmentScheduled ? classes.disabledCellText : classes.cellContent, " cellContent")
  }, "$".concat(params.row.currentBalance ? parseFloat(params.row.currentBalance).toFixed(2) : '0'))));
});